import { Text } from '@loomhq/lens';
import classnames from 'classnames';
import React from 'react';

import styles from './styles.module.less';

const CommentNewFeatureWrapper = props => {
  const { onEmbedPlayer } = props;

  const tooltipClasses = classnames(
    styles.newExperienceTooltip,
    styles.engagementBar,
    {
      [styles.newExperienceEmbed]: onEmbedPlayer,
      [styles.newExperienceShare]: !onEmbedPlayer,
    }
  );

  return (
    <>
      <div className={styles.newExperienceWrapper}>{props.children}</div>

      <div className={tooltipClasses}>
        <Text size="small" isInline={true} fontWeight="bold">
          New!{' '}
        </Text>
        {!onEmbedPlayer && (
          <Text size="small" isInline={true}>
            Leave feedback at the right moment with in-video comments
          </Text>
        )}
      </div>
    </>
  );
};

export default CommentNewFeatureWrapper;
